import { severeWeatherNotifiedDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getsevereWeatherNotifiedEn = () => {
  const data = severeWeatherNotifiedDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addsevereWeatherNotified = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-get-notified-and-prepare-for-severe-weather`,
    ) &&
    document.getElementById(`severeWeatherNotifiedJSONLD`) === null
  ) {
    const script = SevereWeatherNotifiedJSONLDEn()
    addJSONLDToHead(script, `severeWeatherNotifiedJSONLD`)
  } else {
    removeElement(`severeWeatherNotifiedJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const SevereWeatherNotifiedJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getsevereWeatherNotifiedEn(),
  }
  return FaqBagsterTemplate
}
